import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  @Input() preview: boolean = false;
  @Output() onLoggedAdmin = new EventEmitter();
  public alert: boolean = false;

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });


  constructor(
    private userService: UsersService
  ) { }

  ngOnInit(): void { }

  login() {
    this.userService.login({ username: this.loginForm.value.username, password: this.loginForm.value.password }).subscribe(login_value => {
      if (this.preview) {
        this.onLoggedAdmin.emit(login_value.access_token);
      }
      this.alert = false;
    },
      err => {
        this.alert = true;
        this.loginForm.reset();
      }
    );
  }


}
